module.exports = __webpack_public_path__ + "static/media/report_sinister.0fa12c21.svg";